import { render, staticRenderFns } from "./DegreeDetail.vue?vue&type=template&id=cecaa52a&scoped=true&"
import script from "./DegreeDetail.vue?vue&type=script&lang=js&"
export * from "./DegreeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cecaa52a",
  null
  
)

export default component.exports